import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Configuration } from '../conf/app.constants';

@Component({
  selector: 'logout-msg',
  templateUrl: 'logout-msg-view.template.html'
})
export class LogoutMsgViewComponent {

  constructor(public translateService: TranslateService, public configuration: Configuration) { }



}
